import { ActionsTypes } from './actions';

const initialState = {
    messages: [],
    count: 0,
    currentMessage: null,
    loading: false,
    error: false,
    sending: false,
    sendSuccess: false,
    sendError: false,
};

const reducer = (state = initialState, action) => {
    let newState = state;
    switch (action.type) {
        // Fetch messages
        case ActionsTypes.FETCH_MESSAGES_REQUEST:
            newState = { ...state, loading: true, error: false };
            break;
        case ActionsTypes.FETCH_MESSAGES_SUCCESS:
            newState = {
                ...state,
                messages: action.payload.data,
                count: action.payload.count,
                loading: false,
                error: false
            };
            break;
        case ActionsTypes.FETCH_MESSAGES_FAILURE:
            newState = { ...state, loading: false, error: true };
            break;

        // Fetch single message
        case ActionsTypes.FETCH_SINGLE_MESSAGE_REQUEST:
            newState = { ...state, loading: true, error: false };
            break;
        case ActionsTypes.FETCH_SINGLE_MESSAGE_SUCCESS:
            newState = {
                ...state,
                currentMessage: action.payload,
                loading: false,
                error: false
            };
            break;
        case ActionsTypes.FETCH_SINGLE_MESSAGE_FAILURE:
            newState = { ...state, loading: false, error: true };
            break;

        // Send message
        case ActionsTypes.SEND_MESSAGE_REQUEST:
            newState = { ...state, sending: true, sendSuccess: false, sendError: false };
            break;
        case ActionsTypes.SEND_MESSAGE_SUCCESS:
            newState = {
                ...state,
                messages: [action.payload, ...state.messages],
                sending: false,
                sendSuccess: true,
                sendError: false
            };
            break;
        case ActionsTypes.SEND_MESSAGE_FAILURE:
            newState = { ...state, sending: false, sendSuccess: false, sendError: true };
            break;

        // Mark as read
        case ActionsTypes.MARK_MESSAGE_READ_SUCCESS:
            newState = {
                ...state,
                messages: state.messages.map(msg =>
                    msg.id === action.payload ? { ...msg, isRead: true } : msg
                )
            };
            break;

        default:
            break;
    }
    return newState;
};

export default reducer;

